import React from 'react';
import { CTAButton } from './CTAButton';
const pills = ['120 Printable Builds', 'No Special Kit Required', 'Instant Digital Access'];
export function Hero() {
  return <section className="w-full bg-ivory px-5 pb-14 pt-10 sm:pb-20 sm:pt-14" data-id="element-116" data-mp="9ktcvkgndww6">
      <div className="mx-auto flex max-w-4xl flex-col items-center text-center" data-id="element-117" data-mp="9ipbpaa4vbzl">
        <span className="inline-block rounded-full border border-navy/15 bg-white px-4 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.14em] text-navy shadow-sm sm:text-[11px]" data-id="element-118" data-mp="4na1csbc3y7x">
          <span className="text-yellow" aria-hidden="true" data-id="element-119" data-mp="xbpcv4v9byei">
            ✦
          </span>{' '}
          120 hands-on STEM builds for curious kids
        </span>

        <h1 className="mt-6 max-w-3xl font-serif-display text-[32px] font-bold leading-[1.08] tracking-tight text-navy sm:text-[52px] md:text-[64px]" data-id="element-120" data-mp="ncgjad4b0lso">
          In one afternoon, your child can build a{' '}
          <span className="text-spark" data-id="element-121" data-mp="381xl8y8vx2a6">real invention</span>—with{' '}
          <span className="text-spark" data-id="element-122" data-mp="384s5aonzkl32">materials you already have at home</span>.
        </h1>

        <p className="mt-6 max-w-2xl text-base leading-relaxed text-navy/75 sm:text-lg" data-id="element-123" data-mp="3j6ocnm8x2qr5">
          Not just something to keep them busy. 120 hands-on STEM builds that help curious kids ages
          5–12 imagine, build, test, and proudly say, “I made this.”
        </p>

        <ul className="mt-7 flex flex-wrap items-center justify-center gap-2 sm:gap-3" data-id="element-124" data-mp="3e7uxzqhw8tpe">
          {pills.map(pill => <li key={pill} className="flex items-center gap-2 rounded-full border border-blue/20 bg-blueprint px-4 py-2 text-xs font-bold text-navy sm:text-sm" data-id="element-125" data-mp="30g6lvn7na58f">
              <span className="text-teal" aria-hidden="true" data-id="element-126" data-mp="2qi0mpdd83d79">
                ✓
              </span>
              {pill}
            </li>)}
        </ul>

        <div className="mt-9 w-full max-w-md" data-id="element-127" data-mp="2hkglg4fd1gwn">
          <CTAButton label="GET THE FULL INVENTOR LAB" data-id="element-128" data-mp="2lkqwvwlx8ziw" />
          <p className="mt-3 text-xs font-semibold text-navy/70 sm:text-sm" data-id="element-129" data-mp="2lk8vklkejv44">
            One-time payment · Digital download · Ages 5–12
          </p>
        </div>

        <figure className="mt-10 w-full max-w-[880px] sm:mt-12" data-id="element-130" data-mp="nb1kz5gpvtwy">
          <div className="relative overflow-hidden rounded-[28px] bg-white shadow-[0_28px_60px_-28px_rgba(17,35,63,0.38)]" data-id="element-131" data-mp="n9i7fmmg3wyv">
            <img src="https://cdn.magicpatterns.com/uploads/jze1DvQSNW9NBNp8Aujw8J/young-inventor-lab-hero-16x9.webp" alt="Two children at a sunlit table building a balloon-powered car and a balance bird, with printed Young Inventor Lab build cards in front of them" width="1600" height="900" loading="eager" decoding="async" sizes="(max-width: 880px) calc(100vw - 40px), 880px" className="block aspect-[16/9] w-full object-cover" data-id="element-132" data-mp="ddnfu208urjy" />
            <div className="pointer-events-none absolute inset-0 rounded-[28px] ring-1 ring-inset ring-white/40" aria-hidden="true" data-id="element-133" data-mp="3lque9na2654j" />
          </div>
        </figure>
      </div>
    </section>;
}